export default __webpack_public_path__ + "static/media/srv.24a18a63.png";